import { debounce } from 'lodash';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLabor, updateProps } from '../../../contextRedux/Labor/LaborModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { LaborColumn } from './LaborColumn';

const LaborTable: React.FC<any> = () => {
  const dispatch = useDispatch();
  const reduxLabor = useSelector((state: RootState) => state.models?.labor);
  const labors = useSelector((state: RootState) => state.store?.labor.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxLabor.props.skip / reduxLabor.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setLabor(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxLabor.props.take,
    total: reduxLabor.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxLabor.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={labors ?? []}
        pagination={paginationConfig}
        columns={LaborColumn(handleEdit)}
        rowKey='id'
      />
    </>
  );
};

export default LaborTable;
